import React, { useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import {  useNavigate, useParams } from 'react-router-dom';
import { BASE_URL } from '../config/apiConfig';

function PaymentSuccess() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [showCelebration, setShowCelebration] = React.useState(false);
  const [orderData, setOrderData] = useState(null);
  const [error, setError] = useState("");
 
  // After successful fetch and updating localStorage
  localStorage.removeItem("cart"); // This clears the cart
  window.dispatchEvent(new Event("cartCleared")); // Trigger event for same-tab updates

  // Get order data from location state or use mock data
  useEffect(() => {
    const fetchOrderData = async () => {
      try {
        const response = await fetch(`${BASE_URL}/order-details/${orderId}`);

        if (!response.ok) {
          throw new Error(`Error fetching order: ${response.statusText}`);
        }

        const data = await response.json();
        setOrderData(data);
        setLoading(false);
        setTimeout(() => setShowCelebration(true), 300);
      } catch (err) {
        console.error(err);
        setError("Unable to fetch your order. Please try again later.");
        setLoading(false);
      }
    };

    fetchOrderData();
  }, [orderId]);
 
  React.useEffect(() => {
    // Simulate loading and then show celebration
    setTimeout(() => {
      setLoading(false);
      setShowCelebration(true);
    }, 1000);
  }, []);
 
  const handleContinueShopping = () => {
  navigate('/');
};
 
  if (loading) {
    return (
      
<div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-green-50 flex items-center justify-center">
<div className="text-center">
<div className="animate-spin rounded-full h-12 w-12 border-4 border-red-200 border-t-green-600 mx-auto mb-4"></div>
<p className="text-gray-700 text-lg">Processing your order...</p>
</div>
</div>
    );
  }
 
  return (
    <>
    <Header/>
<div className="min-h-screen bg-gradient-to-br from-red-50 via-white to-green-50 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Celebration Animations */}
      {showCelebration && (
<div className="absolute inset-0 pointer-events-none">
          {/* Snowflakes */}
          {Array.from({ length: 20 }).map((_, i) => (
<div
              key={`snowflake-${i}`}
              className="absolute animate-snowfall"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${4 + Math.random() * 2}s`,
              }}
>
<svg className="w-4 h-4 text-blue-200 opacity-70" fill="currentColor" viewBox="0 0 24 24">
<path d="M12 2L13.09 8.26L19 7L17.74 13.26L24 12L17.74 10.74L19 17L13.09 15.74L12 22L10.91 15.74L5 17L6.26 10.74L0 12L6.26 13.26L5 7L10.91 8.26L12 2Z"/>
</svg>
</div>
          ))}
 
          {/* Stars */}
          {Array.from({ length: 15 }).map((_, i) => (
<div
              key={`star-${i}`}
              className="absolute animate-twinkle"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
              }}
>
<svg className="w-3 h-3 text-yellow-400" fill="currentColor" viewBox="0 0 24 24">
<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
</svg>
</div>
          ))}
 
          {/* Holly leaves */}
          {Array.from({ length: 8 }).map((_, i) => (
<div
              key={`holly-${i}`}
              className="absolute animate-float"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
              }}
>
<svg className="w-6 h-6 text-green-600 opacity-60" fill="currentColor" viewBox="0 0 24 24">
<path d="M12 2C10.9 2 10 2.9 10 4C10 5.1 10.9 6 12 6C13.1 6 14 5.1 14 4C14 2.9 13.1 2 12 2M12 8C10.9 8 10 8.9 10 10C10 11.1 10.9 12 12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8M12 14C10.9 14 10 14.9 10 16C10 17.1 10.9 18 12 18C13.1 18 14 17.1 14 16C14 14.9 13.1 14 12 14Z"/>
</svg>
</div>
          ))}
 
          {/* Confetti */}
          {Array.from({ length: 30 }).map((_, i) => (
<div
              key={`confetti-${i}`}
              className="absolute animate-confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
>
<div
                className={`w-2 h-4 ${
                  ['bg-red-400', 'bg-green-400', 'bg-gold-400', 'bg-red-600', 'bg-green-600'][
                    Math.floor(Math.random() * 5)
                  ]
                } rounded-sm`}
                style={{
                  transform: `rotate(${Math.random() * 360}deg)`,
                }}
              />
</div>
          ))}
</div>
      )}
 
      {/* Main Content */}
<div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full text-center relative z-10 border border-red-100">
        {/* Success Icon */}
<div className="mb-6">
<div className="mx-auto w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center animate-bounce-slow">
<svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
</svg>
</div>
</div>
 
        {/* Success Message */}
<h1 className="text-3xl font-bold text-gray-800 mb-2">
          🎉 Order Placed Successfully!
</h1>
 
        <p className="text-gray-600 mb-6">
          Thank you for your purchase! Your order has been confirmed.
</p>
 
        {/* Order Details */}
<div className="bg-gradient-to-r from-red-50 to-green-50 rounded-lg p-6 mb-6 border border-red-100">
<div className="space-y-3">
<div className="flex justify-between items-center">
<span className="text-gray-600 font-medium">Order ID:</span>
<span className="text-gray-800 font-bold">{orderData.id}</span>
</div>
 
            <div className="flex justify-between items-center">
<span className="text-gray-600 font-medium">Customer:</span>
<span className="text-gray-800 font-bold">{orderData.customer_name}</span>
</div>
 
 
            <div className="flex justify-between items-center">
<span className="text-gray-600 font-medium">Items:</span>
<span className="text-gray-800 font-bold">{orderData.total_items}</span>
</div>
</div>
</div>
 
 
        {/* Continue Shopping Button */}
<button
          onClick={handleContinueShopping}
          className="w-full bg-red-600 hover:bg-green-600 text-white font-bold py-4 px-6 rounded-lg transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
>
          🛍️ Continue Shopping
</button>
 
        {/* Additional Info */}
{/* <p className="text-gray-500 text-sm mt-4">
          You will receive an email confirmation shortly.
</p> */}
</div>
 
      {/* Custom CSS Styles */}
<style jsx>{`
        @keyframes snowfall {
          0% {
            transform: translateY(-100vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(360deg);
            opacity: 0;
          }
        }
 
        @keyframes twinkle {
          0%, 100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.2);
          }
        }
 
        @keyframes float {
          0%, 100% {
            transform: translateY(0px) rotate(0deg);
          }
          50% {
            transform: translateY(-20px) rotate(180deg);
          }
        }
 
        @keyframes confetti {
          0% {
            transform: translateY(-100vh) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
 
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
 
        .animate-snowfall {
          animation: snowfall linear infinite;
        }
 
        .animate-twinkle {
          animation: twinkle 2s ease-in-out infinite;
        }
 
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
 
        .animate-confetti {
          animation: confetti linear infinite;
        }
 
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
 
        .bg-gold-400 {
          background-color: #fbbf24;
        }
      `}</style>
</div>
<Footer/>
</>
  );
}
 
export default PaymentSuccess;